<template>
    <div class="content d-flex justify-content-center align-items-center">
        <div class="flex-fill">
            <div class="text-center mb-3">
                <h1 class="error-title">404</h1>
                <h5>{{ $t('alerts.pageNotFound') }}</h5>
            </div>
            <div class="row">
                <div class="col-xl-4 offset-xl-4 col-md-8 offset-md-2">
                        <div class="row">
                        <div class="col-sm-12">
                            <router-link :to="{name: 'Home'}" class="btn btn-primary btn-block legitRipple">
                                <i class="icon-home4 mr-2"></i> {{ $t('buttons.home') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NotFoundPage",
}
</script>